import { render, staticRenderFns } from "./EndlessList.vue?vue&type=template&id=65404b47&"
import script from "./EndlessList.vue?vue&type=script&lang=js&"
export * from "./EndlessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports